import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowLeft, FiCalendar, FiUser, FiTag, FiDownload } from 'react-icons/fi';
import api from '../utils/api';

export default function ProjectDetail() {
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [activeImg, setActiveImg] = useState(0);
  const [loading, setLoading] = useState(true);
  const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

  useEffect(() => {
    api.get(`/projects/${id}`).then(r => setProject(r.data)).catch(() => {}).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [id]);

  if (loading) return <div style={{ paddingTop: 120, textAlign: 'center', color: 'var(--gray-400)', fontFamily: 'Outfit, sans-serif' }}>Loading...</div>;
  if (!project) return <div style={{ paddingTop: 120, textAlign: 'center' }}><h2>Project not found</h2><Link to="/projects">Back to Projects</Link></div>;

  const files = typeof project.files === 'string' ? JSON.parse(project.files || '[]') : (project.files || []);

  return (
    <div style={{ paddingTop: 74 }}>
      <section style={{ background: 'linear-gradient(135deg, #060F1E 0%, var(--navy) 100%)', padding: '4rem 0 3rem' }}>
        <div className="container">
          <Link to="/projects" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.4rem', color: 'rgba(255,255,255,0.5)', fontSize: '0.82rem', marginBottom: '1.5rem' }}>
            <FiArrowLeft /> Back to Projects
          </Link>
          {project.category && <span className="label" style={{ marginBottom: '0.75rem', display: 'inline-flex' }}>{project.category}</span>}
          <h1 style={{ fontFamily: 'Fraunces, serif', fontSize: 'clamp(1.8rem,4vw,2.8rem)', color: 'white', maxWidth: 700, lineHeight: 1.15 }}>{project.title}</h1>
          <div style={{ display: 'flex', gap: '1.5rem', marginTop: '1.5rem', flexWrap: 'wrap' }}>
            {project.client && <span style={{ color: 'rgba(255,255,255,0.6)', display: 'flex', alignItems: 'center', gap: '0.45rem', fontSize: '0.875rem' }}><FiUser style={{ color: '#C9A84C' }} />{project.client}</span>}
            {project.completion_date && <span style={{ color: 'rgba(255,255,255,0.6)', display: 'flex', alignItems: 'center', gap: '0.45rem', fontSize: '0.875rem' }}><FiCalendar style={{ color: '#C9A84C' }} />{new Date(project.completion_date).toLocaleDateString('en-GB', { month: 'long', year: 'numeric' })}</span>}
            {project.category && <span style={{ color: 'rgba(255,255,255,0.6)', display: 'flex', alignItems: 'center', gap: '0.45rem', fontSize: '0.875rem' }}><FiTag style={{ color: '#C9A84C' }} />{project.category}</span>}
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: '4rem', alignItems: 'start' }}>
            <div>
              {project.images?.length > 0 && (
                <div style={{ marginBottom: '2.5rem' }}>
                  <motion.img key={activeImg} initial={{ opacity: 0 }} animate={{ opacity: 1 }} src={`${BACKEND}${project.images[activeImg]}`} alt="Project" style={{ width: '100%', height: 420, objectFit: 'cover', borderRadius: '16px', marginBottom: '0.75rem' }} />
                  {project.images.length > 1 && (
                    <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
                      {project.images.map((img, i) => (
                        <img key={i} src={`${BACKEND}${img}`} alt="" onClick={() => setActiveImg(i)} style={{ width: 76, height: 56, objectFit: 'cover', borderRadius: '8px', cursor: 'pointer', border: `2.5px solid ${i === activeImg ? 'var(--gold)' : 'transparent'}`, opacity: i === activeImg ? 1 : 0.55, transition: 'all 0.2s' }} />
                      ))}
                    </div>
                  )}
                </div>
              )}
              {project.videos?.map((v, i) => (
                <video key={i} controls style={{ width: '100%', borderRadius: '12px', marginBottom: '1rem' }}><source src={`${BACKEND}${v}`} /></video>
              ))}
              <h2 style={{ fontFamily: 'Fraunces, serif', fontSize: '1.5rem', color: 'var(--navy)', marginBottom: '1rem' }}>Project Overview</h2>
              <p style={{ color: 'var(--gray-600)', lineHeight: 1.9, fontSize: '0.97rem' }}>{project.description}</p>
              {files.length > 0 && (
                <div style={{ marginTop: '2rem', padding: '1.5rem', background: 'var(--off-white)', borderRadius: '14px', border: '1px solid var(--gray-200)' }}>
                  <h3 style={{ fontFamily: 'Fraunces, serif', fontSize: '1rem', marginBottom: '1rem', color: 'var(--navy)' }}>Downloads</h3>
                  {files.map((f, i) => (
                    <a key={i} href={`${BACKEND}${f.path}`} download style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.75rem 1rem', background: 'white', borderRadius: '8px', marginBottom: '0.5rem', border: '1px solid var(--gray-200)', color: 'var(--navy)', fontWeight: 500, fontSize: '0.875rem' }}>
                      <FiDownload style={{ color: 'var(--gold)' }} />{f.name}
                    </a>
                  ))}
                </div>
              )}
            </div>
            <div style={{ position: 'sticky', top: '6rem' }}>
              <div style={{ background: 'var(--navy)', padding: '2rem', borderRadius: '20px', color: 'white', marginBottom: '1.5rem' }}>
                <h3 style={{ fontFamily: 'Fraunces, serif', color: '#C9A84C', marginBottom: '1.5rem', fontSize: '1.1rem' }}>Project Details</h3>
                {[['Client', project.client], ['Category', project.category], ['Completed', project.completion_date ? new Date(project.completion_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : null]].filter(d => d[1]).map(([label, val]) => (
                  <div key={label} style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
                    <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.3rem' }}>{label}</div>
                    <div style={{ color: 'white', fontWeight: 500, fontSize: '0.9rem' }}>{val}</div>
                  </div>
                ))}
              </div>
              <div style={{ background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))', padding: '2rem', borderRadius: '16px' }}>
                <h3 style={{ fontFamily: 'Fraunces, serif', color: 'var(--navy)', marginBottom: '0.75rem', fontSize: '1.1rem' }}>Need Similar Help?</h3>
                <p style={{ color: 'rgba(11,37,69,0.7)', fontSize: '0.875rem', marginBottom: '1.25rem', lineHeight: 1.6 }}>Let us help your business achieve similar results.</p>
                <Link to="/book-service" className="btn btn-navy" style={{ width: '100%', justifyContent: 'center', fontSize: '0.875rem' }}>Book a Consultation</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
